import enableFancybox from "./fancybox.js";
import {onReady} from "../../../../modules/vegas/js/util";

onReady(() => {
	setTimeout(enableFancybox, 1)
});

typeof onTurboRender !== 'undefined' && onTurboRender(enableFancybox);
